import { ALL_PRODUCT_TYPES, hasMidstream } from "constants/chart.constants";

import { IProductType } from "models/chart";
import { EntityKind } from "models/entityKind";

/**
 * It returns the label of the product that matches the key variable from the ALL_PRODUCT_TYPES object.
 * If no product matches the key variable, it returns the key variable itself.
 *
 * @param {string} key - The key of the product.
 * @returns {string} - The label of the matched product or the key if no product matches.
 */
export function getProductLabel(key: string, entityKind?: string): string {
  let product: IProductType | undefined;
  const hydrocarbonDict = {
    C2: "C₂",
    C3: "C₃",
    C4: "C₄",
    "C5+": "C₅₊"
  };

  if (key in hydrocarbonDict) {
    return hydrocarbonDict[key];
  }

  if (entityKind === EntityKind.Well) {
    product = Object.values(ALL_PRODUCT_TYPES).find(
      (prod: IProductType) => prod.key === key
    );
  } else {
    product = Object.values(ALL_PRODUCT_TYPES).find(
      (prod: IProductType) => prod.key === key && prod.available === hasMidstream
    );
    if (!product) {
      product = Object.values(ALL_PRODUCT_TYPES).find(
        (prod: IProductType) => prod.key === key
      );
    }
  }

  return product ? product.label : key;
}
